// extracted by mini-css-extract-plugin
export default {"cls1":"MrMqR01O_7KIFcn_FVCr","cls2":"Ww2OFBLCs_G0rBkp1oxX MrMqR01O_7KIFcn_FVCr"};